import {Injectable} from "@angular/core";
import {connectApi} from "../connect-api";
import {SESSION_STORAGE_KEYS} from "../session-storage-keys";
import {map} from "rxjs/internal/operators";
import {HttpClient} from "@angular/common/http";
import {SystemConfiguration} from "./system-configuration";
import {CustomHttpParams} from '../connect-http-interceptor';


@Injectable({
    providedIn: 'root'
})
export class SystemConfigurationService {
    systemConfiguration: SystemConfiguration;

    constructor(private  httpClient: HttpClient) {

    }

    loadSystemConfiguration(): void {
        let accountId = sessionStorage.getItem(SESSION_STORAGE_KEYS.customerAccountId);
        let url = connectApi.systemConfiguration.replace('{accountId}', accountId);
        this.httpClient
            .get<SystemConfiguration>(url, {
                params: new CustomHttpParams(true)
            })
            .pipe(map(result => new SystemConfiguration(result['ConfigurationType'])))
            .subscribe((systemConfiguration: SystemConfiguration) => {
                this.systemConfiguration = systemConfiguration
            });
    }
}
